/**
 * 密碼強度規則(設計稿 24:9203;後端文件同一條)。
 * 前端表單先擋一次少一趟來回;mock(假後端)也引這裡 —— 規則全專案只此一份,
 * 原本散在 mock/passwordReset、ResetPassword、AdminResetPasswordDialog 三處(ticket 09 收斂)。
 */
export const PASSWORD_MIN_LENGTH = 8;

/** 回傳違規說明;通過回 null */
export function passwordIssue(password) {
  const value = String(password || "");
  if (value.length < PASSWORD_MIN_LENGTH) return `密碼至少 ${PASSWORD_MIN_LENGTH} 碼。`;
  if (!/[a-z]/.test(value) || !/[A-Z]/.test(value) || !/\d/.test(value)) {
    return "密碼需包含大小寫英文與數字。";
  }
  return null;
}
